import { render, staticRenderFns } from "./Cadastros.vue?vue&type=template&id=474a77e7&scoped=true&"
import script from "./Cadastros.vue?vue&type=script&lang=js&"
export * from "./Cadastros.vue?vue&type=script&lang=js&"
import style0 from "./Cadastros.vue?vue&type=style&index=0&id=474a77e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a77e7",
  null
  
)

export default component.exports